module.exports = {
  baseUrl: process.env.NODE_ENV === 'production'
    ? 'https://scanapi.ticketsys.ro'
    : '/api'
};
